import React, { FC } from "react";

export interface Props {
  position: number;
}

const defaultProps = {
  position: 0
};

const QueuePosition: FC<Props> = (props = defaultProps) => {
  if (props.position <= 0) return null;

  return (
    <div className="system-msg-container">
      <span className="system-msg">Queue position: {props.position}</span>
    </div>
  );
}

export default QueuePosition;
